export default "__VITE_ASSET__B5cg_q66__"